export const postLoginSelector = (state) => state.postLogin.postLogin;
